// extracted by mini-css-extract-plugin
export default {"autocompleteRoot":"FormDetail_autocompleteRoot__08DBm"};